module.exports = __webpack_public_path__ + "img/logo-white.dca653b8.png";